import { HTMLAttributes, SVGProps, JSX } from 'react';
import { Edit, Tag } from '../../icons';
import { cn } from '../../utils';
import { Button } from '../Button';
import { ComboboxOption } from './Combobox';

export type ComboboxTagItemOption = ComboboxOption<{ color?: string }>;

export interface ComboboxTagItemProps
  extends HTMLAttributes<HTMLDivElement>,
    ComboboxTagItemOption {
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  onEdit?: (tag: ComboboxTagItemOption) => void;
}

export const ComboboxTagItem = ({
  label,
  value,
  color,
  icon,
  onEdit,
  ...props
}: ComboboxTagItemProps) => {
  const Icon = icon || Tag;

  return (
    <div
      {...props}
      className={cn(
        'text-medium group flex w-full items-center justify-between gap-2.5',
        props.className
      )}
    >
      <div className="flex items-center gap-2">
        <Icon style={{ color }} />
        <span className="leading-6 font-medium">{label || ''}</span>
      </div>
      {onEdit && (
        <Button
          variant="ghost"
          size="icon"
          className="size-6 opacity-0 transition-opacity group-hover:opacity-100"
          onClick={e => {
            e.stopPropagation();
            onEdit({ label, value, color });
          }}
        >
          <Edit className="size-4" />
        </Button>
      )}
    </div>
  );
};
